import { render, staticRenderFns } from "./MessagesCommercialLog.vue?vue&type=template&id=7596105e"
import script from "./MessagesCommercialLog.vue?vue&type=script&lang=js"
export * from "./MessagesCommercialLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports